import React, { useState } from 'react';
import { colors } from '../../config/constants';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';

const Changepassword = () => {
  const [newpassword, setNewPassword] = useState('');
  const [minChar, setMinChar] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [lowercase, setLowercase] = useState(false);
  const [numcheck, setNumCheck] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);

  const validationHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewPassword(e.target.value);
    // const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    e.target.value.length >= 6 ? setMinChar(true) : setMinChar(false);
    /[A-Z]/.test(e.target.value) ? setUpperCase(true) : setUpperCase(false);
    /[a-z]/.test(e.target.value) ? setLowercase(true) : setLowercase(false);
    /[0-9]/.test(e.target.value) ? setNumCheck(true) : setNumCheck(false);
    // format.test(e.target.value) ? setSpecialChar(true) : setSpecialChar(false);
  };

  return (
    <div className=" bg-white  m-4 p-2 shadow-lg ">
      <div className={`${colors.primary} p-2 text-white`}>Change Password</div>
      <div className="sm:flex items-center my-16">
        <div className="p-4 ml-5 sm:w-2/4">
          <div className="text-[40px] text-[#bfbebb]  text mb-6">
            Change Password
          </div>
          <div className="my-1 text-slate-600 text-sm">Passwords must contains:</div>
          <div className="flex items-center">
            {minChar ? (
              <div>
                <i className="fa-solid fa-check mr-2 text-green-600"></i>
              </div>
            ) : (
              <div>
                <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
              </div>
            )}

            <div className="my-1 text-slate-600 text-sm">At least 6 characters</div>
          </div>
          <div className="flex items-center">
            {upperCase ? (
              <div>
                <i className="fa-solid fa-check mr-2 text-green-600"></i>
              </div>
            ) : (
              <div>
                <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
              </div>
            )}

            <div className="my-1 text-slate-600 text-sm">              
              At least 1 uppercase letter (A-Z)
            </div>
          </div>
          <div className="flex items-center">
            {lowercase ? (
              <div>
                <i className="fa-solid fa-check mr-2 text-green-600"></i>
              </div>
            ) : (
              <div>
                <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
              </div>
            )}

            <div className="my-1 text-slate-600 text-sm">              
              At least 1 lowercase letter (a-z)
            </div>
          </div>
          <div className="flex items-center">
            {numcheck ? (
              <div>
                <i className="fa-solid fa-check mr-2 text-green-600"></i>
              </div>
            ) : (
              <div>
                <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
              </div>
            )}

            <div className="my-1 text-slate-600 text-sm">
              At least 1 number (0-9)
            </div>
          </div>
          <div className="flex items-center">
            {specialChar ? (
              <div>
                <i className="fa-solid fa-check mr-2 text-green-600"></i>
              </div>
            ) : (
              <div>
                <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
              </div>
            )}

            <div className="my-1 text-slate-600 text-sm">
              
              At least 1 special chareacter
            </div>
          </div>
        </div>
        <div className="w-full">
          <div className="my-1 p-4 sm:w-2/4">
            <Input
              label="New Password"
              type="text"
              placeholder="Please enter new password"
              value={newpassword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                validationHandler(e)
              }
            />
            <Input
              label="Confirm Password"
              type="text"
              placeholder="Please enter confirm password"
            />
            <div className="flex items-center mt-6">
              <div className="mr-4">
                <Button label={'submit'} type={'button'} buttonType={'primary'} />
              </div>
              <div>
                <Button label={'cancel'} type={'button'} buttonType={'danger'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Changepassword;
